
<form class="search-form" [formGroup]="form" (submit)="onSubmit()">
  <input type="text" [sdxFocusOn]="true" autocomplete="off"  class="search-input" formControlName="query" placeholder="Type to search...">
  <a class="search-close" *ngIf="!!form.get('query').value" (click)="clear()"><span class="sr-only">clear</span></a>
  <a class="search-icon" *ngIf="!form.get('query').value"><span class="sr-only">search</span></a>
</form>
